export default __webpack_public_path__ + "static/media/385.86629772.png";